import React from "react";
import s from "./Default.module.css"
import ToNews from "../News/ToNews";
import img from "../../assets/News/News1104252.png"
import img1 from "../../assets/News/News1104252_1.jpg"
import img2 from "../../assets/News/News1104252_2.jpg"
import img3 from "../../assets/News/News1104252_3.jpg"
import img4 from "../../assets/News/News1104252_4.jpg"

const News1104252 = () => {

    return <div className={s.page}>
        <h2 style={{
            fontWeight: "normal",
            marginTop: "50px",
            color: "#3a4663",
            textAlign: "left",
            maxWidth: "1100px",
            margin: "40px auto",
            fontFamily: "Proxima Nova Lt"
        }}>
            Состоялись общественные слушания «Система мер по предупреждению и предотвращению последствий влияния букмекерского бизнеса на подростковую и молодежную среду»
        </h2>
        <div>
            <img src={img} />
        </div>
        <div style={{ fontFamily: "Proxima Nova Lt" }}>
            10 апреля 2025 г. в <a href="https://www.oprf.ru/live_stream/3242" style={{ fontWeight: "bold" }}>Общественной палате Российской Федерации</a> состоялись общественные слушания на тему: «Система мер по предупреждению и предотвращению последствий влияния букмекерского бизнеса на подростковую и молодежную среду», организованные Комиссией Общественной палаты Российской Федерации по физической культуре, спорту и здоровому образу жизни (далее – Комиссия).
            <p></p>
            Открыла слушания <b>Винер Ирина Александровна</b>, Председатель Комиссии, Герой Труда Российской Федерации.
            <p></p>
            С докладами выступили депутаты Государственной думы Российской Федерации, члены Комитета по молодежной политике, Комитета по физической культуре и спорту, Комитета по охране здоровья.
            <p></p>
            В дискуссии участвовали представители профильных министерств и ведомств – Минспорта России, Минздрава России, <a href="https://edu.gov.ru/" style={{fontWeight: "bold"}}></a>Минпросвещения России, Минобрнауки России, Минцифры России, Росмолодежи, Юнармии; руководители и представители букмекерского бизнеса, члены Общественной палаты Российской Федерации, региональных Общественных палат, общественность и эксперты темы, СМИ, и др.
            <p></p>
            В слушаниях приняла участие <b>Артамонова Елена Геннадьевна</b>, заместитель директора по развитию системы профилактики девиантного поведения ФГБУ «Центр защиты прав и интересов детей». В ходе дискуссии обсуждались вопросы первичной профилактики, реализация Минпросвещения России задач по формированию у обучающихся установок на здоровый, активный образ жизни, просвещение родителей и повышение компетенций педагогов в вопросах предотвращения развития игровой зависимости (лудомании) у детей и подростков.
            <p></p>
        </div>
        <div>
            <img src={img1} />
        </div>
        <div>
            <img src={img2} />
        </div>
        <div>
            <img src={img3} />
        </div>
        <div>
            <img src={img4} />
        </div>
        <ToNews />
    </div>
}


export default News1104252;